export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/40 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 bg-primary-50 border border-primary-200/60 rounded-full px-4 py-1.5 mb-5">
              <span className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></span>
              <span className="text-xs font-medium text-primary-700 whitespace-nowrap">实时追踪</span>
              <span className="text-xs text-foreground-400">·</span>
              <span className="text-xs font-medium text-primary-700 whitespace-nowrap">全网热点</span>
              <span className="text-xs text-foreground-400">·</span>
              <span className="text-xs font-medium text-primary-700 whitespace-nowrap">每日吃瓜</span>
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight">
              五一吃瓜网
              <br />
              <span className="text-primary-500">网络热门事件追踪平台</span>
            </h1>

            <p className="mt-4 text-lg md:text-xl text-foreground-600 font-medium">
              聚焦网络大事件，不错过每一个热点
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-700 leading-relaxed max-w-xl mx-auto lg:mx-0">
              五一吃瓜网专注于搜罗全网热门事件与最新网络热点，每日更新吃瓜事件汇总与热门爆料追踪。
              无论是最新热搜事件还是网络大事件，这里都为你一站式呈现最全的吃瓜时间线。
              紧跟热点节奏，不错过任何一个值得关注的网络话题。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-5 justify-center lg:justify-start">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-flashlight-line text-accent-500 text-sm"></i>
                </span>
                <span>今日更新 <strong className="text-accent-600">128</strong> 条</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-global-line text-accent-500 text-sm"></i>
                </span>
                <span>覆盖话题 <strong className="text-accent-600">3,600+</strong></span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <span className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-eye-line text-accent-500 text-sm"></i>
                </span>
                <span>日均浏览 <strong className="text-accent-600">50万+</strong></span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#index"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-6 py-3 rounded-full text-sm transition-all whitespace-nowrap cursor-pointer"
              >
                浏览热门专题
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 border-2 border-primary-300 hover:border-primary-500 text-primary-600 font-semibold px-6 py-3 rounded-full text-sm transition-all whitespace-nowrap cursor-pointer"
              >
                我要爆料
                <i className="ri-send-plane-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20modern%20illustration%20of%20social%20media%20trending%20topics%20and%20breaking%20news%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20abstract%20data%20visualization%20with%20floating%20topic%20bubbles%20and%20trending%20arrows%2C%20clean%20minimalist%20design%20with%20soft%20gradients%2C%20modern%20tech%20meets%20editorial%20aesthetic%2C%20engaging%20visual%20narrative%20about%20hot%20topics%20and%20news%20tracking%2C%20no%20text%2C%20professional%20yet%20approachable%20style&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="五一吃瓜网 - 网络热门事件追踪平台主视觉"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}